import { useMemo, useRef, useState } from "react";
import {
  MdFilterList,
  MdKeyboardArrowDown,
  MdOutlineEco,
  MdRestaurant,
  MdDeliveryDining,
  MdCurrencyRupee,
  MdSort,
} from "react-icons/md";

import FilterChip from "./FilterChip";
import DropdownMenu from "./DropdownMenu";
import AdvancedFilterModal from "./AdvancedFilterModal";

import "./FilterBar.css";

const SORT_OPTIONS = [
  { label: "Recommended", value: "" },
  { label: "Rating", value: "rating" },
  { label: "Price: Low to High", value: "priceAsc" },
  { label: "Price: High to Low", value: "priceDesc" },
  { label: "Newest", value: "newest" },
];

const CUISINE_OPTIONS = [
  "South Indian",
  "North Indian",
  "Chinese",
  "Italian",
  "Fast Food",
  "Bakery",
  "Desserts",
  "Beverages",
];

const SERVICE_OPTIONS = [
  "Home Chef",
  "Restaurant",
  "Hotel",
  "Bakery",
  "Cafe",
  "Catering",
  "Provision Store",
];

const BUDGET_OPTIONS = [
  { label: "Under ₹100", value: 100 },
  { label: "Under ₹200", value: 200 },
  { label: "Under ₹300", value: 300 },
  { label: "Under ₹500", value: 500 },
];

function FilterBar({
  filters,
  onFilterChange,
  onReset,
}) {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [dropdownAnchor, setDropdownAnchor] = useState(null);
  const [showAdvanced, setShowAdvanced] = useState(false);

  const chipRefs = useRef({});

  const registerChip = (key) => (element) => {
    chipRefs.current[key] = element;
  };

  const toggleDropdown = (key) => {
    if (activeDropdown === key) {
      setActiveDropdown(null);
      setDropdownAnchor(null);
      return;
    }

    setActiveDropdown(key);
    setDropdownAnchor(chipRefs.current[key]);
  };

  const closeDropdown = () => {
    setActiveDropdown(null);
    setDropdownAnchor(null);
  };

  const activeCount = useMemo(() => {
    let count = 0;

    if (filters.foodType) count++;
    if (filters.category) count++;
    if (filters.providerType) count++;
    if (filters.maxPrice) count++;
    if (filters.fastDelivery) count++;
    if (filters.sort) count++;

    return count;
  }, [filters]);

  return (
    <>
      <div className="filter-bar">

        <div className="filter-scroll">

         <div ref={registerChip("filters")}>

  <FilterChip
    icon={<MdFilterList />}
    label={
      activeCount > 0
        ? `Filters (${activeCount})`
        : "Filters"
    }
    rightIcon={<MdKeyboardArrowDown />}
    active={activeDropdown === "filters"}
    onClick={() => toggleDropdown("filters")}
  />

</div>

          <div ref={registerChip("sort")}>

            <FilterChip
              icon={<MdSort />}
              label={
                filters.sort
                  ? SORT_OPTIONS.find(
                      item => item.value === filters.sort
                    )?.label || "Sort"
                  : "Sort"
              }
              rightIcon={<MdKeyboardArrowDown />}
              active={activeDropdown === "sort"}
              onClick={() => toggleDropdown("sort")}
            />

          </div>

          <FilterChip
            icon={<MdOutlineEco />}
            label="Veg"
            active={filters.foodType === "Veg"}
            onClick={() =>
              onFilterChange(
                "foodType",
                filters.foodType === "Veg" ? "" : "Veg"
              )
            }
          />

          <FilterChip
            icon={<MdRestaurant />}
            label="Non Veg"
            active={filters.foodType === "Non Veg"}
            onClick={() =>
              onFilterChange(
                "foodType",
                filters.foodType === "Non Veg"
                  ? ""
                  : "Non Veg"
              )
            }
          />
                    <div ref={registerChip("category")}>

            <FilterChip
              icon={<MdRestaurant />}
              label={
                filters.category
                  ? filters.category
                  : "Cuisine"
              }
              rightIcon={<MdKeyboardArrowDown />}
              active={activeDropdown === "category"}
              onClick={() => toggleDropdown("category")}
            />

          </div>

          <div ref={registerChip("provider")}>

            <FilterChip
              icon={<MdDeliveryDining />}
              label={
                filters.providerType
                  ? filters.providerType
                  : "Services"
              }
              rightIcon={<MdKeyboardArrowDown />}
              active={activeDropdown === "provider"}
              onClick={() => toggleDropdown("provider")}
            />

          </div>

          <div ref={registerChip("budget")}>

            <FilterChip
              icon={<MdCurrencyRupee />}
              label={
                filters.maxPrice
                  ? `Under ₹${filters.maxPrice}`
                  : "Budget"
              }
              rightIcon={<MdKeyboardArrowDown />}
              active={activeDropdown === "budget"}
              onClick={() => toggleDropdown("budget")}
            />

          </div>

          <FilterChip
            icon={<MdDeliveryDining />}
            label="Fast Delivery"
            active={filters.fastDelivery}
            onClick={() =>
              onFilterChange(
                "fastDelivery",
                !filters.fastDelivery
              )
            }
          />

        </div>
      </div>

      {activeDropdown === "sort" && (
        <DropdownMenu
          anchorEl={dropdownAnchor}
          options={SORT_OPTIONS}
          selected={filters.sort}
          onSelect={(value) => {
            onFilterChange("sort", value);
            closeDropdown();
          }}
          onClose={closeDropdown}
        />
      )}

      {activeDropdown === "category" && (
        <DropdownMenu
          anchorEl={dropdownAnchor}
          options={CUISINE_OPTIONS.map((item) => ({
            label: item,
            value: item,
          }))}
          selected={filters.category}
          onSelect={(value) => {
            onFilterChange("category", value);
            closeDropdown();
          }}
          onClose={closeDropdown}
        />
      )}

      {activeDropdown === "provider" && (
        <DropdownMenu
          anchorEl={dropdownAnchor}
          options={SERVICE_OPTIONS.map((item) => ({
            label: item,
            value: item,
          }))}
          selected={filters.providerType}
          onSelect={(value) => {
            onFilterChange("providerType", value);
            closeDropdown();
          }}
          onClose={closeDropdown}
        />
      )}
            {activeDropdown === "budget" && (
        <DropdownMenu
          anchorEl={dropdownAnchor}
          options={BUDGET_OPTIONS}
          selected={filters.maxPrice}
          onSelect={(value) => {
            onFilterChange("maxPrice", value);
            closeDropdown();
          }}
          onClose={closeDropdown}
        />
      )}

     {activeDropdown === "filters" && (
  <DropdownMenu
    anchorEl={dropdownAnchor}
    options={[
      { label: "Rating 4+", value: "rating" },
      { label: "Open Now", value: "openNow" },
      { label: "Offers Only", value: "offersOnly" }
    ]}
    selected=""
    onSelect={(value) => {
      onFilterChange(value, true);
      closeDropdown();
    }}
    onClose={closeDropdown}
  />
)}
    </>
  );
}

export default FilterBar;